export enum SharedEventEnum {
  SendEmail = 'sendEmail',
  SendSMS = 'sendSMS',
}

export enum StockStatus {
  InStock = 'inStock',
  True = 'true',
  False = 'false',
  OutOfStock = 'outStock', // Add any other statuses as needed
}

export enum NotificationType {
  SMS = 'sms',
  FCM = 'fcm',
  MQTT = 'mqtt',
  EMAIL = 'email',
  BULK_EMAIL = 'bulk_email',
  SOCIALS = 'socials',
  DEALS = 'deals',
  CAMPAIGNS = 'campaigns',
  CONTENT_CHEF = 'content_chef',
  ANALYTICS = 'analytics',
  JOURNEYS = 'journeys',
  INVENTORY = 'inventory',
  GIFT_CARD_INVENTORY_IMPORT = 'gift_card_inventory_import',
  ARM = 'arm',
  ACTIVITY_LOG = 'activity_log',
  ARM_STORE_REVIEW = 'arm_store_reviews',
  IMPORT_GUESTS = 'import_guests',
}

export enum ReportQueueStatus {
  IN_QUEUE = 'in-queue',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
  PUBLISH = 'published',
  CANCELLED = 'cancelled',
}

export enum PlatformEnvironment {
  PRODUCTION = 'prod',
  STAGING = 'stagev2',
}

export enum ToastStatus {
  WARNING = 'Warning',
  SUCCESS = 'Success',
  INFO = 'Info',
}
export enum AppEnvironmentsVariables {
  DEVELOPMENT = 'development',
  POS = 'pos',
  ONLINE = 'online',
  MAIN = 'qa',
  IT = 'it',
  INTERNAL = 'internal',
  KDS = 'kds',
  DASHBOARD = 'dashboard',
  WEB = 'web',
  KIOSK = 'kiosk',
  MOM = 'mom',
  UAT = 'uatv2',
  STAGE = 'stage',
  STAGEV2 = 'stagev2',
  MENU = 'menu',
  PROD = 'prod',
}

export enum ServerEnums {
  ANDROMEDARELAY = 'andromedarelay',
  BACKEND = 'backend',
  COSMICJOBS = 'cosmicjobs',
  GRAVITONCORTEX = 'gravitoncortex',
  NEBULASTREAM = 'nebulastream',
}

export const AWS_ACL: Record<AppEnvironmentsVariables, boolean> = {
  [AppEnvironmentsVariables.DEVELOPMENT]: true,
  [AppEnvironmentsVariables.POS]: true,
  [AppEnvironmentsVariables.ONLINE]: true,
  [AppEnvironmentsVariables.MAIN]: false,
  [AppEnvironmentsVariables.IT]: false,
  [AppEnvironmentsVariables.INTERNAL]: true,
  [AppEnvironmentsVariables.KDS]: true,
  [AppEnvironmentsVariables.DASHBOARD]: true,
  [AppEnvironmentsVariables.KIOSK]: true,
  [AppEnvironmentsVariables.MOM]: true,
  [AppEnvironmentsVariables.WEB]: true,
  [AppEnvironmentsVariables.UAT]: false,
  [AppEnvironmentsVariables.MENU]: true,
  [AppEnvironmentsVariables.STAGE]: false,
  [AppEnvironmentsVariables.STAGEV2]: false,
  [AppEnvironmentsVariables.PROD]: false,
};

export const cloudFrontUrls: Record<string, string> = {
  development: 'dashboard-demo-assests.s3.us-west-2.amazonaws.com',
  internal: 'aio-dashboard-filestore-internal.s3.us-west-2.amazonaws.com',
  uatv2: 'dlczzqexv58na.cloudfront.net',
  menu: 'aio-dashboard-filestore.s3.us-west-2.amazonaws.com',
  web: 'website-builder-demo.s3.us-west-2.amazonaws.com',
  qa: 'd1v3kx4suurdh4.cloudfront.net',
  stagev2: 'd397eean0u41g4.cloudfront.net',
  prod: 'd3lo736arv80hj.cloudfront.net',
  it: 'd1v3kx4suurdh4.cloudfront.net',
  vegas: 'aio-dashboard-filestore.s3.us-west-2.amazonaws.com',
};

export const defaultBucket = 'dashboard-demo-assests';

export const aspectRatios = {
  '1x1': '1x1',
  '16x9': '16x9',
};
